import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import * as MenuListUI from 'components/MenuList';
import PopoverCard from 'components/PopoverCard';
import { useMenuContext } from './Menu';
function MenuList(_ref) {
  var children = _ref.children;
  var _useMenuContext = useMenuContext(),
    popover = _useMenuContext.popover,
    menuListProps = _useMenuContext.menuListProps;
  return /*#__PURE__*/React.createElement(PopoverCard, _extends({
    renderWhenClosed: true,
    renderInPlace: false,
    isOpen: popover.isOpen
  }, popover.props, {
    ref: popover.setRef,
    arrow: popover.arrow
  }), /*#__PURE__*/React.createElement(MenuListUI.Wrapper, _extends({
    as: "div"
  }, menuListProps), children));
}
export default MenuList;